// const state = {
// 	token: localStorage.getItem("LOGIN_STATUS_TOKEN") || false,
// 	userInfo: {},
// 	homeActive: false,
// 	phoneStatus:true,
// };

// const mutations = {
// 	SETPHONESTATUS(state,val){
// 		state.phoneStatus = val;
// 	},
// 	LOGIN(state, opt) {
// 		state.token = opt.token;
// 		localStorage.setItem("LOGIN_STATUS_TOKEN",opt.token)
// 	},
// 	UPDATE_LOGIN(state, token) {
// 		state.token = token;
// 	},
// 	LOGOUT(state) {
// 		state.token = undefined;
// 		state.uid = undefined
// 		localStorage.removeItem('LOGIN_STATUS_TOKEN')
// 	},
// 	UPDATE_USERINFO(state, userInfo) {
// 		state.userInfo = userInfo;
// 		localStorage.setItem("USER_INFO",JSON.stringify(userInfo));
// 	},
// 	OPEN_HOME(state) {
// 		state.homeActive = true;
// 	},
// 	CLOSE_HOME(state) {
// 		state.homeActive = false;
// 	},
// 	FOOT_UPLOAD(state,data){
// 		state.pageFooter = data
// 	}
// };
// export default {
// 	state,
// 	mutations,
// };



export default {
  state: {
   token: false,
   userInfo: null,
   homeActive: false,
   phoneStatus:true,
  },
  getters: {
    // // menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    // errorCount: state => state.errorList.length
  },
  mutations: {
    SETPHONESTATUS(state,val){
    	state.phoneStatus = val;
    },
    LOGIN(state, opt) {
    	state.token = opt.token;
    },
    UPDATE_LOGIN(state, token) {
    	state.token = token;
    },
    LOGOUT(state) {
    	state.token = undefined;
    	state.uid = undefined
    },
    UPDATE_USERINFO(state, userInfo) {
    	state.userInfo = userInfo;
    },
    OPEN_HOME(state) {
    	state.homeActive = true;
    },
    CLOSE_HOME(state) {
    	state.homeActive = false;
    },
    FOOT_UPLOAD(state,data){
    	state.pageFooter = data
    }
  },
}
